import { render, staticRenderFns } from "./role.vue?vue&type=template&id=2ba2118e&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=2ba2118e&prod&lang=css"
import style1 from "./role.vue?vue&type=style&index=1&id=2ba2118e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2118e",
  null
  
)

export default component.exports